define(['text!./templates/stepper.html'], (templateStr)=> {
    /** Base stepper directive. This one is responsible for displaying a current value and for displaying
     * "previous" and "next" buttons.
     */
    return [()=> {
        return {
            restrict: 'A',
            template: templateStr,

            scope: {
                'displayValue': '=',
                'havePrevValue': '=',
                'haveNextValue': '=',

                'selectPrevValue': '&',
                'selectNextValue': '&'
            }
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/inputs/Stepper.js